import React, { useState } from 'react';
import styled from 'styled-components';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VegetableSelection from './components/VegetableSelection';
import GameScreen from './components/GameScreen';
import InstallPrompt from "./InstallPrompt";
import { WebSocketProvider } from './contexts/WebSocketContext'; // Import the provider

const AppContainer = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.$isGameStarted ? '#000000' : '#f5f5f5'};
    transition: background-color 1s ease;
    overflow: hidden; /* Contains the overflow within this container */

    /* This ensures the content inside can scroll if needed */
    & > * {
        max-height: 100%;
        overflow-y: auto;
    }
`;

function App() {
    const [isGameStarted, setIsGameStarted] = useState(false);
    const [selectedVegetable, setSelectedVegetable] = useState(null);
    const [showEyesMessage, setShowEyesMessage] = useState(true);

    const handleVegetableSelect = (vegetable) => {
        if (vegetable.name.toLowerCase() === 'tomato') {
            toast.error('Tomatoes are fruits, not vegetables.', {
                position: "top-center",
                autoClose: 3000,
            });
            return;
        }

        setSelectedVegetable(vegetable);
        setIsGameStarted(true);

        const startsWithVowel = /^[aeiou]/i.test(vegetable.name);

        toast.info(`You are a${startsWithVowel ? 'n' : ''} ${vegetable.name.toLowerCase()}.`, {
            position: "top-center",
            autoClose: 3000,
        });

        if (showEyesMessage) {
            setTimeout(() => {
                toast.dark('Vegetables don\'t have eyes.', {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                setShowEyesMessage(false);
            }, 6000);
        }
    };

    return (
        <WebSocketProvider>
            <AppContainer $isGameStarted={isGameStarted}>
                {!isGameStarted ? (
                    <VegetableSelection onSelect={handleVegetableSelect} />
                ) : (
                    <GameScreen selectedVegetable={selectedVegetable} />
                )}
                <ToastContainer />
                <InstallPrompt />
            </AppContainer>
        </WebSocketProvider>
    );
}

export default App;
